import React from "react";
import "./Tag.scss";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';
import classNames from "classnames";

const Tag = ({
  title,
  isWithoutRemovebutton,
  type,
  onRemoveTag,
}) => {
  

  const finallyTagClassName = classNames({
    'tag': true,
    'primary': type === 'primary',
  })

  return (
    <div className={finallyTagClassName}>
      <p className="tag__text">
        {title}
      </p>

      {
        onRemoveTag && (
          <>
            <div
              className="tag__icon-wrapper"
              onClick={onRemoveTag}
            >
              <CloseIcon className="tag__icon"/>
            </div>
          </>
        )
      }
      
    </div>
  );
};

export default Tag;
